"use client";

import { gtmSendEvent } from "@wojo/analytics";
import { useI18n } from "@wojo/localization";
import { StoryblokImage } from "@wojo/storyblok";
import { Button, Card, Text } from "@wojo/ui";
import React, { useState } from "react";
import { TourEquipmentContent } from "../../../generated/graphql";
import style from "./Equipment.module.scss";
import { EquipmentModal } from "./EquipmentModal";

type EquipmentCardProps = {
    equipment: TourEquipmentContent;
    /** where in the array the item is placed */
    itemIndex: number;
};

export const CARD_WIDTH = 280;

export const EquipmentCard: React.FC<EquipmentCardProps> = ({
    equipment,
    itemIndex,
}) => {
    const productPage = useI18n("productPage");
    const [openEquipmentModal, setOpenEquipmentModal] = useState(false);

    return (
        <React.Fragment>
            <Card
                variant="standard"
                key={equipment.name}
                style={{ width: CARD_WIDTH }}
                className={style.card}
                tag="button"
                onClick={() => {
                    gtmSendEvent({
                        event: "track",
                        ga4Tracking: {
                            ga4_object: "EQUIPMENT_MODAL",
                            ga4_action: "OPENED",
                            modalId: "Equipment Modal",
                            heading: equipment.name || "",
                        },
                    });
                    setOpenEquipmentModal(true);
                }}
            >
                {equipment.cardImage?.filename && (
                    <StoryblokImage
                        className={style["card-image"]}
                        mobile={{
                            asset: equipment.cardImage,
                            size: {
                                width: CARD_WIDTH * 2,
                            },
                        }}
                    />
                )}
                <div className={style["card-content-wrapper"]}>
                    <Text.Heading
                        order="5"
                        tag="h3"
                        style={{ marginBottom: "var(--g-spacing-xxs)" }}
                    >
                        {equipment.name}
                    </Text.Heading>
                    <Text.Body
                        style={{
                            marginBottom: "var(--g-spacing-xxs)",
                            fontStyle: "italic",
                        }}
                    >
                        {equipment.detailedName}
                    </Text.Body>
                    <Text.Body style={{ marginBottom: "var(--g-spacing-sm)" }}>
                        {equipment.price}
                    </Text.Body>
                    <Button tag="span" variant="quiet">
                        {productPage.productPage.equipment.modalTriggerLabel.l()}
                    </Button>
                </div>
            </Card>
            {openEquipmentModal && (
                <EquipmentModal
                    selectedIndex={itemIndex}
                    open={openEquipmentModal}
                    onCloseRequested={() => {
                        gtmSendEvent({
                            event: "track",
                            ga4Tracking: {
                                ga4_object: "EQUIPMENT_MODAL",
                                ga4_action: "CLOSED",
                                modalId: "Equipment Modal",
                                heading: equipment.name || "",
                            },
                        });
                        setOpenEquipmentModal(false);
                    }}
                />
            )}
        </React.Fragment>
    );
};
